<template>
  <el-dialog
    :visible.sync="innerVisible"
    :title="isEdit?$t('SeaExport.Edit'):$t('SeaExport.Add')"
    :close-on-click-modal="false"
    width="768px"
  >
    <el-form label-width="165px" inline label-position="left">
      <el-form-item label="UN No" class="marginLeft">
        <el-input ref="txtUnNo" v-model="imdgCode.unNo" :disabled="isEdit" />
      </el-form-item>
      <el-form-item label="Special Provisions" class="marginLeft">
        <el-input v-model="imdgCode.specialProvisions" />
      </el-form-item>
      <br>
      <el-form-item label="PSN" class="marginLeft">
        <el-input v-model="imdgCode.psn" />
      </el-form-item>
      <el-form-item label="Limited Quantities" class="marginLeft">
        <el-input v-model="imdgCode.limitedQuantities" />
      </el-form-item>
      <br>
      <el-form-item label="Class" class="marginLeft">
        <el-input v-model="imdgCode.classification" />
      </el-form-item>
      <el-form-item label="Excepted Quantitiess" class="marginLeft">
        <el-input v-model="imdgCode.exceptedQuantities" />
      </el-form-item>
      <br>
      <el-form-item label="Subsidiary Risks" class="marginLeft">
        <el-input v-model="imdgCode.subsidiaryRisks" />
      </el-form-item>
      <el-form-item label="Flashpoint" class="marginLeft">
        <el-input v-model="imdgCode.flashpoint" />
      </el-form-item>
      <br>
      <el-form-item label="Packing Group" class="marginLeft">
        <el-input v-model="imdgCode.packingGroup" />
      </el-form-item>
      <el-form-item label="Emergency Schedule" class="marginLeft">
        <el-input v-model="imdgCode.emergencySchedule" />
      </el-form-item>
      <br>
      <el-form-item label="Packing Instructions" class="marginLeft">
        <el-input v-model="imdgCode.packingInstruction" />
      </el-form-item>
      <el-form-item label="Packing Provisions" class="marginLeft">
        <el-input v-model="imdgCode.packingProvisions" />
      </el-form-item>
      <br>
      <el-form-item label="IBCs Instructions" class="marginLeft">
        <el-input v-model="imdgCode.ibcsInstruction" />
      </el-form-item>
      <el-form-item label="IBCs Provisions" class="marginLeft">
        <el-input v-model="imdgCode.ibcsProvisions" />
      </el-form-item>
      <br>
      <el-form-item label="Tanks Instructions" class="marginLeft">
        <el-input v-model="imdgCode.tanksInstruction" />
      </el-form-item>
      <el-form-item label="Tanks Provisions" class="marginLeft">
        <el-input v-model="imdgCode.tanksProvisions" />
      </el-form-item>
      <br>
      <el-form-item label="Stowage and Handling" class="marginLeft">
        <el-input v-model="imdgCode.stowageHandling" />
      </el-form-item>
      <el-form-item label="Segregation" class="marginLeft">
        <el-input v-model="imdgCode.segregation" />
      </el-form-item>
      <br>
      <el-form-item label="Properties and Observations" class="marginLeft">
        <el-input v-model="imdgCode.propertiesObservations" />
      </el-form-item>
    </el-form>
    <div slot="footer" style="text-align: center;">
      <el-button type="primary" @click="saveHandler">{{ $t('common.btn.save') }}</el-button>
      <el-button @click="closeHandler">{{ $t('common.btn.close') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import * as imdgCodeApi from '@/api/sysManage/imdgCode'
import { getLoading } from '@/utils/utilBaseElement'

export default {
  name: 'FormDialog',
  props: {
    visible: { type: Boolean, required: true },
    isEdit: { type: Boolean, required: true },
    uuid: { type: String, default: '' }
  },
  data() {
    return {
      innerVisible: false,
      imdgCode: {
        unNo: '',
        psn: '',
        classification: '',
        subsidiaryRisks: '',
        packingGroup: '',
        packingInstruction: '',
        ibcsInstruction: '',
        tanksInstruction: '',
        stowageHandling: '',
        propertiesObservations: '',
        specialProvisions: '',
        limitedQuantities: '',
        exceptedQuantities: '',
        flashpoint: '',
        emergencySchedule: '',
        packingProvisions: '',
        ibcsProvisions: '',
        tanksProvisions: '',
        segregation: ''
      }
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
      if (newVal) {
        this.loadImdgCode()
      }
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  },
  methods: {
    loadImdgCode() {
      if (this.isEdit) {
        imdgCodeApi.queryIMDGCodeByUuid({ uuid: this.uuid }).then(resp => {
          Object.assign(this.imdgCode, resp.data)
        })
      } else {
        this.imdgCode = this.getInitForm()
      }
    },
    saveHandler() {
      const msg = this.validateIMDG()
      if (msg) {
        this.$message.warning(msg)
        return
      }
      this.fillModel()
      if (!this.imdgCode.uuid) {
        imdgCodeApi.isUniqueUnNo({ unNo: this.imdgCode.unNo }).then(resp => {
          this.isUniqueUnNoResultHandler(resp)
        })
      } else {
        const loading = getLoading()
        imdgCodeApi.saveIMDGCode(this.imdgCode).then(resp => {
          this.saveIMDGCodeHandler()
        }).finally(() => loading.close())
      }
    },
    isUniqueUnNoResultHandler(resp) {
      const isUnique = resp.data
      if (!isUnique) {
        this.$message.warning(this.$t('Information.UnitedNationsNumberAlreadyExists'))
        return
      }
      const loading = getLoading()
      imdgCodeApi.saveIMDGCode(this.imdgCode).then(resp => {
        this.saveIMDGCodeHandler()
      }).finally(() => loading.close())
    },
    saveIMDGCodeHandler() {
      this.$emit('saveCallBack')
      this.closeHandler()
    },
    validateIMDG() {
      let msg = ''
      if (!this.imdgCode.unNo.trim()) {
        msg = this.$t('Message.UNNoIsEmpty')
        this.$refs.txtUnNo.focus()
      }
      return msg
    },
    fillModel() {
      const imdgCode = this.imdgCode
      if (imdgCode) {
        const initForm = this.getInitForm()
        for (const key in initForm) {
          const val = imdgCode[key]
          if (val) {
            imdgCode[key] = val.trim()
          }
        }
      }
    },
    closeHandler() {
      this.$emit('close')
    },
    getInitForm() {
      return {
        unNo: '',
        psn: '',
        classification: '',
        subsidiaryRisks: '',
        packingGroup: '',
        packingInstruction: '',
        ibcsInstruction: '',
        tanksInstruction: '',
        stowageHandling: '',
        propertiesObservations: '',
        specialProvisions: '',
        limitedQuantities: '',
        exceptedQuantities: '',
        flashpoint: '',
        emergencySchedule: '',
        packingProvisions: '',
        ibcsProvisions: '',
        tanksProvisions: '',
        segregation: ''
      }
    }
  }
}
</script>

<style scoped>
.marginLeft {
  margin-left: 30px;
}
</style>
